// extracted by mini-css-extract-plugin
export var content = "_3y-3";
export var list = "_3y-4";
export var settingsContent = "_3y-7";
export var settingsPanel = "_3y-8";
export var state = "_3y-6";
export var triggerBadge = "_3y-2";
export var triggerButton = "_3y-1";
export var triggerShell = "_3y-0";
export var unreadDot = "_3y-5";